




import { Component, Mixins, Prop } from "vue-property-decorator";
import {
  IHisInformationValue,
  HisInformationTextValue,
  HisInformationDateTimeValue,
} from "../../../domain/his/HisInformationValue";
import { HisInformationItem } from "../../../domain/his";
import { HisItemBehaviorFactory } from "../../../domain/his/behavior";
import HisTextItemComponent from "./HisTextItemComponent.vue";
import HisDateTimeItemComponent from "./HisDateTimeItemComponent.vue";
import DiseaseMainComponent from "./DiseaseMainComponent.vue";

@Component({
  components: {
    HisTextItemComponent,
    HisDateTimeItemComponent,
    DiseaseMainComponent,
  },
})
export default class HisItemComponent extends Mixins() {
  @Prop()
  hisItemKey: string;
  @Prop()
  hisItems: HisInformationItem[];
  @Prop()
  dateFormat: string;

  private static readonly _componentDirectory: { [key: string]: string } = {
    DISEASE_MAIN: "DiseaseMainComponent",
  };

  get componentKey(): string {
    const componentName = HisItemComponent._componentDirectory[this.hisItemKey];
    if (componentName != null) { return componentName; }

    if (this.hisInfoValue instanceof HisInformationTextValue) { return "HisTextItemComponent"; }
    if (this.hisInfoValue instanceof HisInformationDateTimeValue) { return "HisDateTimeItemComponent"; }
    return "HisTextItemComponent";
  }

  get hisInfoValue(): IHisInformationValue {
    const behavior = HisItemBehaviorFactory.create(this.hisItemKey, this.dateFormat);
    const hisInfoValue = behavior.getValue(this.hisItems);
    return hisInfoValue;
  }
}
